import * as XLSX from 'xlsx';

export function formatColHeader(col) {
  return col.replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function exportToCSV(rows, columns, filename) {
  const header = columns.map(formatColHeader).join(',');
  const body = rows.map(row =>
    columns.map(col => {
      const val = row[col] ?? '';
      // wrap in quotes if contains comma or newline
      const str = String(val).replace(/"/g, '""');
      return /[,\n"]/.test(str) ? `"${str}"` : str;
    }).join(',')
  ).join('\n');

  const blob = new Blob([header + '\n' + body], 
    { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportToExcel(rows, columns, filename) {
  const header = [columns.map(formatColHeader)];
  const body = rows.map(row => columns.map(col => row[col] ?? ''));
  const ws = XLSX.utils.aoa_to_sheet([...header, ...body]);
  
  // Style header row bold if possible (SheetJS free version has limited styling)
  // But we can at least ensure the workbook structure is correct
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, filename);
}
